var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"d":"M22.121,10.706,12.706,1.293A1,1,0,0,0,12,1H2A1,1,0,0,0,1,2V12a1,1,0,0,0,.293.707l9.413,9.415a3,3,0,0,0,4.243,0l7.172-7.172a3,3,0,0,0,0-4.243ZM8,10a2,2,0,1,1,2-2A2,2,0,0,1,8,10Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }